module.exports = __webpack_public_path__ + "static/poty_screen-7b411553b3be68efba13ff32b58c742a.png";